import React from 'react';
import { ArcStack } from '@src/core/ui';
import { useSelectedFleetDrone } from '@src/features/fleet/pages/drones-page/hooks';
import { SectionWrapperProps } from './types';

const SectionWrapper: React.FC<SectionWrapperProps> = (props) => {
  const { children } = props;
  const { hasDrone } = useSelectedFleetDrone();

  if (!hasDrone) return null;

  return <ArcStack py={3} px={5} paddingTop={2}> {children} </ArcStack>;
};

export default SectionWrapper;